import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { useForm } from '../../../../packages/kiti/components/form/form/FormHandler'
import EditWidgetForm from '../../../../containers/screens/widgets/EditWidgetForm'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import Select from '../../../../packages/kiti/components/form/Select'

const GeneralSection = () => {
  const { t } = useTranslation('screens')
  const form = useForm()

  return (
    <Grid paddingGutter={0.5} wrap>
      <Col width="100%">
        <FormItem label={t('name')} field="name" />
      </Col>

      <EditWidgetForm />
    </Grid>
  )
}
export default GeneralSection
